type ProviderTypeOrSpecialty = {
  id: string;
  name: string;
};

export function JobPostProviderSpecialties({
  providerTypes,
  specialties,
}: {
  providerTypes?: readonly ProviderTypeOrSpecialty[] | null;
  specialties?: readonly ProviderTypeOrSpecialty[] | null;
}) {
  return (
    <p className="min-w-0 whitespace-normal text-sm leading-6 text-slate-600 [overflow-wrap:anywhere]">
      <strong className="font-semibold text-slate-900">
        {specialties?.length
          ? specialties.map((specialty) => specialty.name).join(", ")
          : "Specialties not specified"}
      </strong>
      <span className="text-slate-400"> · </span>
      {providerTypes?.length
        ? providerTypes.map((type) => type.name).join(", ")
        : "Provider type not specified"}
    </p>
  );
}
